import {createAction, props} from '@ngrx/store';
import {Region} from '../../../services/api/account/regions/region.model';

const category = '[OrganizationRegions]';

export const loadOrganizationRegions = createAction(
    `${category} Load Organization Regions`
);

export const loadOrganizationRegionsSuccess = createAction(
    `${category} Load Organization Regions Success`,
    props<{ data: Region[] }>()
);

export const loadOrganizationRegionsFailure = createAction(
    `${category} Load Organization Regions Failure`,
    props<{ error: any }>()
);

export const clearOrganizationRegionsState = createAction(
    `${category} Clear Organization Regions State`
);
